// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2PVh0","title":"styles_title__1XLxw","selects":"styles_selects__3pM40","saveButton":"styles_saveButton__2Oqv_"};